module.exports = __webpack_public_path__ + "img/15.81e41937.jpg";